define('view/finder/external.org.adder.view',['require','exports','module','underscore','handlebars','backbone','uikit/uikit'],function(require, exports, module) {
  //prettier-ignore
  var _          = require('underscore'),
      Handlebars = require('handlebars'),
      Backbone   = require('backbone'),
      UIKit      = require('uikit/uikit');

  var ERROR_CLASS = 'ui top attached error message';
  var NO_ERROR_CLASS = 'ui basic segment';

  var ErrorStateObject = Backbone.Model.extend({
    defaults: {
      hasVisibleFailedValidations: false,
    },
  });

  var ExternalOrgAdderView = UIKit.ItemView.extend({
    template: function() {
      return '<div class="ui segment"><div class="answer-wrapper ui basic segment" style="background: transparent;"><ui name="nameView"/></div><ui name="errorMessageView"/></div>';
    },

    model: function() {
      return this.getOption('model');
    },

    ui: {
      answerWrapper: '.answer-wrapper',
    },

    errorCollection: new Backbone.Collection(),

    errorStateObject: new ErrorStateObject(),

    addError: function(message) {
      this.errorCollection.add({ message: message });
      this.errorStateObject.set('hasVisibleFailedValidations', true);
      this.ui.answerWrapper
        .removeClass(NO_ERROR_CLASS)
        .addClass(ERROR_CLASS)
        .css({
          'margin-top': '',
          'margin-bottom': '',
        });
    },

    clearErrors: function() {
      this.errorCollection.reset();
      this.errorStateObject.set('hasVisibleFailedValidations', false);
      this.ui.answerWrapper
        .removeClass(ERROR_CLASS)
        .addClass(NO_ERROR_CLASS)
        .css({
          'margin-top': '0',
          'margin-bottom': '0',
        });
    },

    internalViewOptions: {
      requiredQuestionView: function() {
        return {
          type: UIKit.Text,
          model: this.getOption('model'),
          color: 'red',
          text: '*',
        };
      },

      nameView: function() {
        var parent = this;
        return {
          type: UIKit.Input.extend({
            label: new Handlebars.SafeString('External Org Name <span class="red text">*</span>'),
            required: true,
            className: UIKit.Input.prototype.className + ' fluid',
            validate: function() {
              this.clearErrors();

              if (this.ui.input && this.ui.input.val) {
                var val = this.ui.input.val();

                if (!val) {
                  this.addError('This question requires an answer.');
                } else if (!val.match(/[a-zA-Z]+/)) {
                  this.addError('The answer must contain at least one alphabetic character.');
                }

                this.ui.input.val(this.ui.input.val());
              }
            },
          }),
          placeholder: 'Add organization...',
          required: true,
          addError: function(message) {
            parent.addError(message);
          },
          clearErrors: function() {
            parent.clearErrors();
          },
          isValid: function() {
            return this.ui.input && this.ui.input.val && this.ui.input.val() && !parent.errorCollection.length;
          },
          model: this.getOption('model'),
          bindings: {
            value: 'name',
          },
        };
      },

      errorMessageView: function() {
        return {
          type: UIKit.Message,
          className: UIKit.Message.prototype.className + ' bottom attached',
          text: 'Error:',
          format: 'error',
          collection: this.errorCollection,
          model: this.errorStateObject,
          bindings: {
            visible: 'hasVisibleFailedValidations',
          },
          childBindings: {
            text: 'message',
          },
        };
      },
    },
  });
  module.exports = ExternalOrgAdderView;
});

